import { fetchData, withFilteredCatalogue } from "../../Helpers";

export const HOMEPAGE_STALE_TIME = 1000 * 60 * 5.5;
export const HOMEPAGE_CACHE_TIME = Infinity;

export async function getCouponHomepageList(
  payload = {
    offset: 0,
  }
) {
  const controller = new AbortController();
  const result = await fetchData({
    endpoint: "/coupon/catalogue/dashboard/list",
    successCallback: resObj => {
      dataLayer.push({
        "event": "view_catalogue_list",
        ...resObj.data
      })
    },
    controller: controller,
    payload: payload,
  });

  return withFilteredCatalogue(result);
}
export async function getActivationHomepageList(
  payload = {
    limit: 50,
    offset: 0,
  }
) {
  const controller = new AbortController();
  const result = await fetchData({
    endpoint: "/activation/dashboard/list",
    successCallback: resObj => {
      dataLayer.push({
        "event": "view_activation_list",
        ...resObj.data
      })
    },
    payload: payload,
    controller: controller,
  });

  if (!result.activations) {
    return []
  }

  return result.activations.sort(
    (a, b) =>
      Number(a.completed) - Number(b.completed)
  )?.slice(0, 3)
}
